import { useEffect } from 'react';
import { useShallow } from 'zustand/react/shallow';
// utils
import useAppStore from '@/store/app';
import { useProfileQuery } from '@/services/customer/profile/profile.queries';
import socket from '@/modules/Sockets/Sockets.utils';

interface InitAppProps {
    isAuthorized: boolean;
}

const InitApp = ({ isAuthorized }: InitAppProps) => {
    const { data: profile, isSuccess } = useProfileQuery(isAuthorized);

    const { accessToken, setCustomerId } = useAppStore(
        useShallow((state) => ({
            accessToken: state.accessToken,
            setCustomerId: state.setCustomerId
        }))
    );

    useEffect(() => {
        if (accessToken) {
            socket.emit('auth', {
                event_type: 'auth',
                data: {
                    message_type: 'auth_request',
                    message_content: accessToken
                }
            });
        }
    }, [accessToken]);

    useEffect(() => {
        if (profile?.id) {
            setCustomerId(profile.id);
        }
    }, [profile?.id, isSuccess, setCustomerId]);
    return false;
};

export default InitApp;
